import {Routes} from "@angular/router";
import {OnboardingPage} from "./page/onboarding-page/onboarding.page";
import {authGuard} from "../core/auth/auth.guard";
import {
  ScheduleAppointmentWhatsappComponent
} from "../cross/schedule/component/schedule-appointment-whatsapp/schedule-appointment-whatsapp.component";

export function ObSubRoutes(): Routes {

  /**
   *
   * path:
   * Prefix of the module will always be added to the path name
   *
   *      Example
   *      path: "addresses" => route path "ad/addresses" !
   * ------------------------------------------------------------------
   *
   * component:
   * Added components need to be from type "Page"!
   * ------------------------------------------------------------------
   *
   */
  const routes: Routes = [

    {path: 'ob/start', redirectTo: 'ob/start/1', pathMatch: "full"},
    {path: 'ob/start/:step', component: OnboardingPage, canActivate: [authGuard]},
    // {path: 'ob/schedule-appointment-type-whatsapp', component: VCardComponent},

  ];

  return routes;

}
